/* eslint-disable */ import { assertBoolean, attachSingleReferenceComponent, attributeSwitchComponent, childEntityRecipesComponent, composedOfComponent, dimensionIndicatorComponent, memoEval, referenceComponent, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { FixingHole } from '../model/index.js';
export const plateComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withAlias('Plate').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachComponent.withComponent(composedOfComponent, '$customBend', true).withAlias('Plate').attach(memoEval((self)=>[
            self.$customBend?.id ?? null
        ], (id)=>({
            childEntityIds: id === null ? [] : [
                id
            ]
        }))),
    attachComponent.withComponent(composedOfComponent, '$holes', true).withAlias('Plate').attach(memoEval((self)=>self.$holes.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'Plate.$powderCoatingMountingHole', true).withAlias('Plate'), FixingHole, 'powderCoatingMountingHoleId'),
    attachComponent.withComponent(attributeSwitchComponent, 'powderCoating', true).withAlias('Plate').attach(memoEval((self)=>[
            self.powderCoating
        ], (powderCoating)=>({
            value: powderCoating
        })), (state)=>{
        assertBoolean(state.value);
        return {
            powderCoating: state.value
        };
    }),
    attachComponent.withComponent(childEntityRecipesComponent, 'boltHole', true).withAlias('Plate').attach(memoEval((self)=>[
            self.$boltHoleRecipes
        ], ($boltHoleRecipes)=>({
            groupLabel: 'Bolt Hole',
            groupDescription: 'Add bolt holes for fixing your plate.',
            recipes: $boltHoleRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'countersinkHole', true).withAlias('Plate').attach(memoEval((self)=>[
            self.$countersinkHoleRecipes
        ], ($countersinkHoleRecipes)=>({
            groupLabel: 'Countersink Hole',
            groupDescription: 'Add countersink holes for fixing your plate.',
            recipes: $countersinkHoleRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'cylinderHole', true).withAlias('Plate').attach(memoEval((self)=>[
            self.$cylinderHoleRecipes
        ], ($cylinderHoleRecipes)=>({
            groupLabel: 'Cylinder Hole',
            groupDescription: 'Choose the right cylinder hole for your lock.',
            recipes: $cylinderHoleRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'locksetHole', true).withAlias('Plate').attach(memoEval((self)=>[
            self.$locksetHoleRecipes
        ], ($locksetHoleRecipes)=>({
            groupLabel: 'Lockset Hole',
            groupDescription: 'Choose the right lockset hole for your lock.',
            recipes: $locksetHoleRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'shapeHole', true).withAlias('Plate').attach(memoEval((self)=>[
            self.$shapeHoleRecipes
        ], ($shapeHoleRecipes)=>({
            groupLabel: 'Shape Hole',
            groupDescription: 'Add a basic shape hole to your plate.',
            recipes: $shapeHoleRecipes
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'sizeX', true).withAlias('Plate').withFilter((self)=>({
            navigationStates: [
                'Dimensions',
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization',
                'FinalizationThumbnail'
            ],
            toolStates: [
                'Configure'
            ],
            active: self.$sizeXIndicatorFilter
        })).attach(memoEval((self)=>[
            self.$sizeX,
            self.$middleZ,
            self.$sizeIndicatorExtrusion,
            self.$indicatorLabelFontSize
        ], ($sizeX, $middleZ, $sizeIndicatorExtrusion, $indicatorLabelFontSize)=>({
            startX: 0,
            endX: $sizeX,
            startY: 0,
            endY: 0,
            startZ: $middleZ,
            endZ: $middleZ,
            extrusionY: $sizeIndicatorExtrusion,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $indicatorLabelFontSize
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'sizeY', true).withAlias('Plate').withFilter((self)=>({
            navigationStates: [
                'Dimensions',
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization',
                'FinalizationThumbnail'
            ],
            toolStates: [
                'Configure'
            ],
            active: self.$sizeYIndicatorFilter
        })).attach(memoEval((self)=>[
            self.$sizeY,
            self.$middleZ,
            self.$sizeIndicatorExtrusion,
            self.$indicatorLabelFontSize
        ], ($sizeY, $middleZ, $sizeIndicatorExtrusion, $indicatorLabelFontSize)=>({
            startX: 0,
            endX: 0,
            startY: 0,
            endY: $sizeY,
            startZ: $middleZ,
            endZ: $middleZ,
            extrusionX: $sizeIndicatorExtrusion,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $indicatorLabelFontSize,
            labelAngle: 1.5708
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'radius', true).withAlias('Plate').withFilter(()=>({
            navigationStates: [
                'BulkFinalization',
                'Finalization'
            ]
        })).attach(memoEval((self)=>[
            self.$radiusIndicatorX,
            self.$radiusIndicatorY,
            self.$radiusIndicatorZ,
            self.$radiusIndicatorExtrusion,
            self.$radiusIndicatorExtrusionZ,
            self.$indicatorLabelFontSize,
            self.$radiusIndicatorLabel
        ], ($radiusIndicatorX, $radiusIndicatorY, $radiusIndicatorZ, $radiusIndicatorExtrusion, $radiusIndicatorExtrusionZ, $indicatorLabelFontSize, $radiusIndicatorLabel)=>({
            startX: $radiusIndicatorX,
            endX: $radiusIndicatorX,
            startY: $radiusIndicatorY,
            endY: $radiusIndicatorY,
            startZ: $radiusIndicatorZ,
            endZ: $radiusIndicatorZ,
            extrusionX: $radiusIndicatorExtrusion,
            extrusionZ: $radiusIndicatorExtrusionZ,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $indicatorLabelFontSize,
            label: $radiusIndicatorLabel
        })))
];

//# sourceMappingURL=plate.js.map